import React, {useMemo} from 'react';
import {eventMomentFactory} from '../../../../data/misc/eventMomentFactory';
import Icon from '../../../elements/icons/Icon';
import Link from '../../../elements/Link';
import ListItem from '../../../elements/ListItem/ListItem';
import {ListItemContent} from '../../../elements/ListItem/ListItemContent';
import RightChevron from '../../../elements/RightChevron/RightChevron';
import TimeSpan from '../../../elements/TimeSpan/TimeSpan';
import stylesheet from '../EventDirectory-listItems.module.scss';

const PresentationSession = props => {
    const {event, session} = props,
        date = useMemo(() => {
            return eventMomentFactory(event, session.start_local).format('dddd D MMMM');
        }, [event, session]);

    return (
        <li className="item">
            <div className={stylesheet.date}>{date}</div>
            <ListItem className={stylesheet.item} tagName={Link} href={['.', 'program', session.id].join('/')}>
                <TimeSpan className={stylesheet.time} start={session.start_local} startClassName={stylesheet.content} end={session.end_local}></TimeSpan>
                <ListItemContent>
                    <p className={stylesheet.content}>{session.name}</p>
                    {session.location ? (
                        <p className="text location">
                            <Icon src="/img/location.png" color={event.settings.primary_color} size={14} /> {session.location}
                        </p>
                    ) : null}
                </ListItemContent>
                <RightChevron />
            </ListItem>
        </li>
    );
};

export default PresentationSession;
